import { render, staticRenderFns } from "./NarrowFooter.vue?vue&type=template&id=448d9050&scoped=true&"
import script from "./NarrowFooter.vue?vue&type=script&lang=ts&"
export * from "./NarrowFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d9050",
  null
  
)

export default component.exports